<div *ngIf="state.showIcon && state.typeLabel && state.typeIcon" class="w-full h-full aligner-start">
  <img
    width="21"
    style="max-height: 30px"
    [matTooltip]="state.typeLabel"
    [src]="state.typeIcon"
    [alt]="state.typeLabel"
  />
</div>
